import React, { useEffect, useRef } from "react";
import { PaymentForm, CreditCard } from "react-square-web-payments-sdk";
import squareServices from "../../../api/services/squareupService";
import affiliateServices from "../../../api/services/affiliateServices";
import { notification } from "antd";

interface SquarePayButtonProps {
  setIsComplete: React.Dispatch<React.SetStateAction<boolean>>;
  setPaymentData: React.Dispatch<React.SetStateAction<any>>;
  agreePolicy: boolean;
  paymentInfo: IPaymentInfo;
  amount: number;
  handleFormSubmit?: () => void;
}

const CreditSquareupButton: React.FC<SquarePayButtonProps> = ({
  setIsComplete,
  setPaymentData,
  agreePolicy,
  paymentInfo,
  amount,
  handleFormSubmit,
}) => {
  const applicationId = (
    process.env.REACT_APP_SQUAREUP_APPLICATION_ID || ""
  ).trim();
  const locationId = (process.env.REACT_APP_SQUAREUP_LOCATION_ID || "").trim();

  const isValidApplicationId = (value: string) =>
    /^(sandbox-)?sq0id[bp]-[0-9A-Za-z_-]{10,}$/.test(value);

  const isSquareConfigured = Boolean(
    isValidApplicationId(applicationId) && locationId
  );
  const notifiedRef = useRef(false);

  useEffect(() => {
    if (!isSquareConfigured && !notifiedRef.current) {
      notifiedRef.current = true;
      notification.error({
        message: "Square payment is not configured",
        description: applicationId
          ? "Invalid REACT_APP_SQUAREUP_APPLICATION_ID format (expected something like sandbox-sq0idb-... or sq0idp-...)."
          : "Missing REACT_APP_SQUAREUP_APPLICATION_ID and/or REACT_APP_SQUAREUP_LOCATION_ID. Please contact support or configure environment variables.",
      });
    }
  }, [isSquareConfigured, applicationId]);

  const handlePayment = async (token: string) => {
    console.log("paymentInfo:", paymentInfo);
    const response = await squareServices.createPayment(
      paymentInfo.request_id,
      token,
      amount,
      "USD"
    );
    console.log("Payment response:", response);
    if (response.status === 400) {
      console.error("Error processing payment:", response.error);
      notification.error({
        message: "Payment Error",
        description: response.error,
      });
      return;
    }
    if (response.status === 201) {
      // await handleFormSubmit?.();
      if (paymentInfo.voucher_code) {
        const saleProductResponse = await affiliateServices.createSaleProduct(
          paymentInfo
        );

        if (saleProductResponse.error) {
          console.error(
            "Error creating sale product:",
            saleProductResponse.error
          );
          return;
        }
      }
      notification.success({
        message: "Create Visa Request Successfully",
        description: "Create Visa Request Successfully",
      });
      setPaymentData(response.data);
      setIsComplete(true);
    }
  };

  if (!isSquareConfigured) {
    return (
      <button
        type="button"
        className="w-full flex justify-center items-center py-4 px-6 border font-bold border-transparent rounded-3xl text-white bg-gray-500 cursor-not-allowed"
        disabled
      >
        Square (Credit) unavailable
      </button>
    );
  }

  return (
    <PaymentForm
      applicationId={applicationId}
      locationId={locationId}
      cardTokenizeResponseReceived={(tokenResult) => {
        if (tokenResult.errors) {
          console.error("Tokenization errors:", tokenResult.errors);
          return;
        }
        if (tokenResult.token) {
          handlePayment(tokenResult.token);
        } else {
          console.error("Token is undefined");
        }
      }}
      createPaymentRequest={() => ({
        countryCode: "US",
        currencyCode: "USD",
        total: {
          amount: amount.toString(),
          label: "Total",
        },
      })}
    >
      <CreditCard />
    </PaymentForm>
  );
};

export default CreditSquareupButton;
